module.exports = "<div class=\"right-toolbar__wxapp-hover\" style=\"display:none\">\n    <img class=\"bg\" src=\"//t.focus-res.cn/front-end/image/wxapp-bg.png\" />\n    <div class=\"hover-content\">\n        #if($pfdACode && $!{pfdACode} != \"\")\n        <img src=\"$!{pfdACode}\" />\n        #end\n\n    </div>\n    <div class=\"hover-right\">\n        <p>购房神器-拼房帝</p>\n        <p class=\"small\">微信扫一扫<br/>不用下载就能用</p>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@front-end/common-module-vm/right-toolbar/wxapp-hover/wxapp-hover.html
// module id = 161
// module chunks = 0 6 11 12 13 14 15 16 20